import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "../../lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & { classNameThumb?: string, isChecked?: boolean }
>(({ className, classNameThumb, isChecked, color, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center")}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20">
      <SliderPrimitive.Range
        data-checked={isChecked}
        className={cn("absolute h-full bg-primary ", className)}
      />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      data-checked={isChecked}
      className={cn(
        "block h-5 w-5 rounded-full border border-primary/50 border-white bg-background shadow transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
        className, classNameThumb
      )}
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
